<template>
  <div v-if="showPopup" class="popFixed">
    <div class="masking" @click="closePopup" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>为了您的账户资金安全</p>
        <p>首次存款请先添加电子钱包</p>
      </div>
      <div class="btnCon only">
        <span @click="goAddWallet">添加电子钱包</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoWalletPopup',
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      showPopup: this.show
    }
  },
  watch: {
    show: function(newVal) {
      this.showPopup = newVal
    }
  },
  methods: {
    goAddWallet() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/RegisterUSDT', query: { toDeposit: 1 }})
    },
    closePopup() {
      if (this.$route.path !== '/home') {
        return
      }

      this.showPopup = false
      this.$emit('onClose')
    }
  }
}
</script>
